export const getRange = (from, to) =>
    Array.from({ length: to - from + 1 }, (_, index) => index + from);

export const mixClasses = (classes = []) => classes.join(' ');

export const getRecords = (source) =>
    !source.isLoading && source.hasData ? source.data.records : [];

export const mapSelectOptions = (source, value = 'id', label = 'name') => {
    const scope = !Array.isArray(source) ? getRecords(source) : source;
    return scope.map((item) => ({
        value: item[value],
        label: item[label]
    }));
};
